import { BadgeLink, BadgeList, BadgeTitle } from "atoms";
import { Thumbnail } from "features/images";
import type { Collective } from "../types";

type ArtistProfileCollectivesProps = {
  collectives: Collective[];
  isBadges?: boolean;
};

function ArtistProfileCollectives({
  collectives,
  isBadges = false,
}: ArtistProfileCollectivesProps) {
  return (
    <BadgeList>
      {collectives.map(({ id, name, badge }) => {
        const to = isBadges ? `/badges/${id}` : `/collectives/${id}`;
        const label = isBadges
          ? `See all artists with the ${name} badge`
          : `See all artists in the ${name} collective`;

        return (
          <li key={id}>
            <BadgeLink to={to} aria-label={label}>
              <Thumbnail src={badge} aria-hidden sizes="300px" />
              <BadgeTitle>{name}</BadgeTitle>
            </BadgeLink>
          </li>
        );
      })}
    </BadgeList>
  );
}

export { ArtistProfileCollectives };
